import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
  preAppliedFilters: null, // { from_date, to_date, source, ...homeFilters }
};

export const myreportSlice = createSlice({
  name: "display",
  initialState,
  reducers: {
    showReportWorkspace: (state) => { state.visible = false; },
    makeVisible: (state) => {
      state.visible = !state.visible;
    },
    setPreAppliedFilters: (state, action) => {
      state.preAppliedFilters = action.payload;
    },
    clearPreAppliedFilters: (state) => {
      state.preAppliedFilters = null;
    },
    openNewReportWithFilters: (state, action) => {
      state.visible = false; // Show ReportDashboard (not saved reports list)
      state.preAppliedFilters = action.payload;
    },
  },
});

export const {
  makeVisible,
  showReportWorkspace,
  setPreAppliedFilters,
  clearPreAppliedFilters,
  openNewReportWithFilters,
} = myreportSlice.actions;
export default myreportSlice.reducer;
